<template>
  <section class="st-panel" :class="{ 'st-panel--flush': flush }">
    <header v-if="title || $slots.header" class="st-panel__header">
      <slot name="header">
        <h3 class="st-panel__title">{{ title }}</h3>
      </slot>
      <div v-if="$slots.actions" class="st-panel__actions">
        <slot name="actions" />
      </div>
    </header>
    <div class="st-panel__body" :class="{ 'st-panel__body--flush': flush }">
      <slot />
    </div>
  </section>
</template>

<script setup lang="ts">
defineProps<{
  title?: string;
  /** Remove body padding (e.g. for a panel wrapping a list or canvas). */
  flush?: boolean;
}>();
</script>

<style scoped>
.st-panel {
  display: flex;
  flex-direction: column;
  background: var(--st-surface);
  border: 1px solid var(--st-border);
  border-radius: var(--st-radius-md);
  overflow: hidden;
}
.st-panel__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--st-space-3);
  padding: var(--st-space-3) var(--st-space-4);
  border-bottom: 1px solid var(--st-border);
}
.st-panel__title {
  font-size: var(--st-text-md);
  font-weight: var(--st-weight-semibold);
  color: var(--st-text);
}
.st-panel__actions {
  display: flex;
  align-items: center;
  gap: var(--st-space-2);
}
.st-panel__body {
  padding: var(--st-space-4);
}
.st-panel__body--flush {
  padding: 0;
}
</style>
